import { useEffect } from 'react'
import { Outlet, useLocation, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { defaultLocale, isLocale } from '@/lib/locales'
import { gaPageView } from '@/lib/analytics/ga'
import { SSEAutoConnect } from '@/components/SSEAutoConnect'
import { SupportWidget } from '@/components/support/SupportWidget'
import { PassageEspace } from '@/components/PassageEspace'
import { ScreenShareGlobal } from '@/components/screenShare/ScreenShareGlobal'

export function LocaleLayout() {
  const { locale } = useParams<{ locale: string }>()
  const location = useLocation()
  const { i18n } = useTranslation()

  useEffect(() => {
    const target = isLocale(locale) ? locale : defaultLocale
    if (i18n.language !== target) {
      void i18n.changeLanguage(target)
    }
    document.documentElement.lang = target
  }, [locale, i18n])

  // GA4 : un page_view explicite a chaque changement de route. C'est ce qui fait
  // repartir l'event `signup_complete` (regle GA4 sur /onboarding/step1). No-op si
  // GA4 n'est pas initialise (dev local sans VITE_GA_MEASUREMENT_ID).
  useEffect(() => {
    gaPageView(location.pathname + location.search)
  }, [location.pathname, location.search])

  return (
    <>
      <SSEAutoConnect />
      <Outlet />
      {/* Entre le Téléphone et l'Administration : où l'on arrive. */}
      <PassageEspace />
      <SupportWidget />
      {/* Le partage d'écran avec le support : demande, accord, bandeau. */}
      <ScreenShareGlobal />
    </>
  )
}
